module.exports = __webpack_public_path__ + "img/5.71a80f3b.png";